module.exports = "\n<!--<pre>{{$data|json}}</pre>\n<br/>\n<br/>-->\n<div v-el:item class=\"vue-grid-layout\" :style=\"mergedStyle\">\n    <slot></slot>\n    <grid-item class=\"vue-grid-placeholder\"\n               v-if=\"isDragging\"\n               :x=\"placeholder.x\"\n               :y=\"placeholder.y\"\n               :w=\"placeholder.w\"\n               :h=\"placeholder.h\"\n               :i=\"placeholder.i\"></grid-item>\n</div>\n";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/GridLayout.vue
 ** module id = 66
 ** module chunks = 0
 **/